import { fetchApi } from "./fetchApi";

export async function posLink(menuItem) {
  const url = window.location.href;
  // console.log("url and menu item in api", url, menuItem);
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [menuItem],
      model: "ir.ui.menu",
      method: "get_menu_item_url",
      kwargs: {},
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({
    requestOptions,
    endpoint: `/web/dataset/call_kw/ir.ui.menu/get_menu_item_url`,
  });
}
